import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Select from 'react-select';

let blue = '#04A2DC';

const PickListStyled = styled.div`
    position: relative;
    width: 100%;
    margin-bottom: 5px;
    margin-top: 28px;
    background: transparent;
    
    .transition, .error {
        top: -12px;
        font-size: 10.5px;
    }
    
    .Select-control {
        border: none;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        border-bottom-color: #bcaaa3;
        border-radius: 0;
        height: 34px;
        
        .Select-placeholder {
            display: none;
        }
        
        .Select-value {
            width: 100%;
            background: transparent;
            padding-top: 5px;
            
            .Select-value-label {
                padding-left: 3px;
                font-size: 17.5px;
                color: #3e2723;
            }
        }
        
        .Select-arrow {
            border-top-color: #A0877F;
        }
    }
    
    .Select-option.is-focused {
        background-color: #eeeeee;
    }
    
    .Select--multi .Select-value {
        background-color: #eeeeee;
     }
    
    .Select-menu-outer {
        .Select--multi .Select-value-icon:hover,
        .Select--multi .Select-value-icon:focus {
          background-color: #191919;
          color: #3E2723;
        }
        
        border-top-color: ${blue};
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.15);
        border-radius: 2px;
        height: auto;
        max-height: none;
    }
    
    .Select-menu {
        height: auto;
        max-height: none;
        z-index: 1;
    }
    
    .is-open + .custom-label {
        color: ${blue};
        
        span {
            display: none;
        }
    }
    
    .is-open > .Select-control .Select-arrow {
        border-bottom-color: ${blue};
    }
    
    .has-value.Select--single > .Select-control .Select-value .Select-value-label {
        color: #3e2723;
    }
    
    .is-focused:not(.is-open) > .Select-control {
        border-color: #bcaaa3;
    }
    
    .error {
        color: #CD2028;
        
        .Select-control {
           border-bottom-color: #CD2028;
        }
    }
    
    .select-error {
        .Select-control {
           border-bottom-color: #CD2028;
           .Select-arrow {
                border-top-color: #CD2028;
            }
        }
    }
    
`;

const LabelStyled = styled.div`
    position: absolute;
    pointer-events: none;
    left: 13px;
    top: 13px;
    font-size: 14px;
    color: #bcaaa3;
    transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding-bottom: 5px;
`;

const ErrorSpanStyled = styled.span`
    display: ${props => props.show ? 'inline' : 'none'};
    text-transform: capitalize;
    color: inherit;
    font-weight: 400;
`;

class PickList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };
    }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.value !== this.state.value)) {
            this.setState({ value: nextProps.value });
        }
    }

    handleChange = (val) => {
        this.setState({ value: val },
            this.props.handleChange(val.value));
    };

    render() {
        const options = this.props.options.map(option => ({ value: option, label: option }));

        const transition = this.state.value ? 'transition' : '';
        const error = this.props.error ? 'error' : '';

        if (this.props.error) {
            blue = '#CD2028';
        }

        return (
            <PickListStyled clearfix >
                <Select instanceId={this.props.instanceId}
                        className={`select-${error}`}
                        value={this.state.value}
                        options={options}
                        onChange={this.handleChange}
                        clearable={false}
                        searchable={false}
                        noResultsText={this.props.noResultsText}
                />
                <LabelStyled className={`custom-label ${transition} ${error}`}>
                    {`${this.props.label} `}
                    <ErrorSpanStyled show={this.props.error}>
                        {this.props.getLocalizedText('Required', 'required')}
                    </ErrorSpanStyled>
                </LabelStyled>

            </PickListStyled>
        );
    }
}

PickList.propTypes = {
    instanceId: PropTypes.string,
    value: PropTypes.string,
    noResultsText: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.string),
    handleChange: PropTypes.func.isRequired,
    getLocalizedText: PropTypes.func.isRequired,
    error: PropTypes.bool,
    locale: PropTypes.shape({
        country: PropTypes.string,
        language: PropTypes.string,
        localeCode: PropTypes.string
    })
};

PickList.defaultProps = {
    instanceId: '',
    value: '',
    noResultsText: 'No results found',
    label: '',
    options: [],
    handleChange: (val) => { console.info(`Selected: ${JSON.stringify(val)}`); },
    getLocalizedText: (key, defaultValue) => defaultValue,
    error: false,
    locale: {
        country: 'US',
        language: 'en',
        localeCode: 'en_US'
    }
};

export default PickList;




// WEBPACK FOOTER //
// ./src/components/PickList/index.js